<template>
  <div>
    <v-select
      v-model="locale"
      :items="items"
      item-text="text"
      item-value="value"
      outlined
      dense
      style="width:80px; margin-top: 4px"
      class="mr-2"
    >
      <template v-slot:selection="{ item }">
        <img :src="item.flag" height="13px"/>
      </template>
      <template v-slot:item="{ item }">
        <img :src="item.flag" height="13px"/>
      </template>
    </v-select>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import vuei18n from '@/i18n'

export default {
  data: () => ({
    locale: null,
    items: [
      { value: 'fr', flag: require('@/assets/app/images/flag_fr.png') },
      { value: 'en', flag: require('@/assets/app/images/flag_en.png') },
    ],
  }),
  mounted() {
    this.locale = this.user.data.locale || 'fr'
  },
  computed: {
    ...mapGetters({
      user: "user"
    }),
    vuei18nLocale() {
      return vuei18n.locale
    }
  },
  watch: {
    locale: {
      handler(val, oldVal) {
        if (val) {
          vuei18n.locale = val
        }
        if (val && oldVal) {
          this.$functions.httpsCallable('updateUser')({
            locale: val
          })
        }
      }
    },
    vuei18nLocale: {
      handler(val) {
        // Used when users'locale is changed from another tab (through store getter of user.onSnapshot listener)
        this.locale = val || 'fr'
      }
    }
  }
}
</script>

<style scoped>
  .v-input__slot > fieldset {
    border-width: 0 !important
  }

  .noBorder {
    border: none;
  }
</style>